export const ReferenceQueryKeys = {
  all: ["references"] as const,
  supportTypes: () => [...ReferenceQueryKeys.all, "support-types"] as const,
  subscriberNeeds: () => [...ReferenceQueryKeys.all, "subscriber-needs"] as const,
  siteTypeRef: () => [...ReferenceQueryKeys.all, "site-type-ref"] as const,
  siteLayoutRef: () => [...ReferenceQueryKeys.all, "site-layout-ref"] as const,
};
